<template>
  <div class="nav__bar_container" v-if="isShow">
    <van-nav-bar :z-index="200" fixed>
      <template v-slot:title>
        <slot name="title">{{ app.title }}</slot>
      </template>
      <template v-slot:left v-if="!$route.meta.tabbar && !$route.meta.hideNavbarAction">
        <div @click="onClickLeft" class="left__container" v-if="app.history.length > 1">
          <van-icon name="arrow-left" class="left__icon" />
          <!-- <span>返回</span> -->
        </div>
        <div @click="onClickHome" class="left__container" v-else>
          <van-icon name="wap-home-o" class="left__icon" />
          <!-- <span>首页</span> -->
        </div>
      </template>
      <template v-slot:right>
        <div class="right__container">
          <slot name="right"></slot>
        </div>
      </template>
    </van-nav-bar>
    <div class="fit__placeholder fit__height"></div>
  </div>
</template>

<script>
export default {
  name: 'navbarComponent',
  data() {
    return {
      isShow: true
    }
  },
  created() {
    if (this.$router.history.current.query.hideTopBar) {
      this.isShow = false
    } else {
      this.isShow = !this.$t.getEnv()
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    onClickHome() {
      this.$router.replace('/lottery/shop')
    }
  }
}
</script>

<style lang="less" scoped>
.left__icon {
  position: relative;
  margin-right: 3px;
  font-size: 20px;
}
.fit__placeholder {
  position: relative;
  height: 46px;
  box-sizing: content-box;
}
.fit__height {
  box-sizing: content-box;
}
.left__container {
  // padding-left: 16px;

  span {
    vertical-align: top;
  }
}
// .right__container {
//   padding-right: 16px;
// }

@media only screen and (min-height: 812px) {
  .fit__height {
    padding-top: calc(constant(safe-area-inset-top));
    padding-top: calc(env(safe-area-inset-top));
  }
}
</style>

<style lang="less">
.van-hairline--bottom::after {
  border-bottom-width: 0px;
}
.nav__bar_container {
  .van-nav-bar__left,
  .van-nav-bar__right {
    bottom: unset;
  }
  .van-nav-bar__right {
    right: 0;
    height: 46px;
  }
  .van-nav-bar__left {
    // position: unset;
    // left: 0;
    height: 46px;
  }
  .right__container {
    position: relative;
    top: -45px;
  }

  .van-nav-bar .van-icon {
    color: #323233;
  }
}
</style>
